import FormHelperText from '@mui/material/FormHelperText'
import LevelPicker from 'Components/reusable/InputFields/LevelPicker'
import { useContext } from 'react'
import { ILanguageLevel, ILevel } from 'types/levelItemInterfaces'
import { Context } from '../context'
import { AnyObject, ContextValue, EditableFieldsOfType } from '../types'

/**
 * Checkbox / switch field.
 */
export const DataEditContextLanguageLevelField = <T extends AnyObject>({
  field,
  ...rest
}: {
  field: EditableFieldsOfType<T, ILanguageLevel | null>
} & Omit<Record<string, unknown>, 'onChange' | 'value' | 'error' | 'name'>) => {
  const { flatData, errors, disabled, setFields } = useContext<ContextValue<T>>(Context)

  const handleChange = (newValue: ILevel | null) => {
    setFields({ [field]: newValue as unknown as ILanguageLevel })
  }

  const value = flatData[field] as unknown as ILevel
  const error = errors[field]

  return (
    <>
      <LevelPicker kind="language" value={value} disabled={disabled[field]} onChange={handleChange} {...rest} />
      {error && <FormHelperText>{error}</FormHelperText>}
    </>
  )
}

/**
 * Interest level picker.
 */
